import { createApi } from "@reduxjs/toolkit/query/react";
import { GET_ORDER, GET_TRACK_ORDER, RE_ORDER } from "../routes";
import baseQuery from "../baseQuery";
export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getOrder: builder.query({
      query: (customer_id: number) => ({
        url: GET_ORDER,
        params: { customer_id },
      }),
      transformResponse: (response: ApiResponse<OrderTypes[]>) => {
        return response?.data;
      },
    }),
    getTrackOrder: builder.query({
      query: (order_id: number) => ({
        url: GET_TRACK_ORDER,
        params: { order_id },
      }),
      transformResponse: (response: ApiResponse<trackOrderTypes>) => {
        return response?.data;
      },
    }),
    reOrder: builder.mutation<
      CartResponse,
      {
        customer_id: number;
        order_id: number
      }
    >({
      query: (credentials) => ({
        url: RE_ORDER,
        method: "POST",
        body: credentials,
      }),
    }),
  }),
});

export const { useLazyGetOrderQuery, useLazyGetTrackOrderQuery, useReOrderMutation } = orderApi;
